import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'capacitacion-empresas',
  templateUrl: './capacitacion-empresas.component.html',
  styleUrls: ['./capacitacion-empresas.component.css']
})
export class CapacitacionEmpresasComponent implements OnInit {

  capEmpresas: string = "assets/images/design/cursos-empresas.jpg"
  ensenaPredyc: string = "assets/images/design/ensena-predyc.jpg"
  registerForm: FormGroup;
  habilitarEnviar: number = 0;
  enviado = false;

  constructor(private formBuilder: FormBuilder, private seo: SeoService, private functions: AngularFireFunctions) { }

  ngOnInit(): void {
    this.seo.generateTags({
      title: "Capacitación para empresas",
      image: "assets/images/logos/logo.svg",
      description: "Inicia un plan de formación junto con tu equipo de trabajo. Desarrolla el perfil profesional de cada miembro."
    })
    this.registerForm = this.formBuilder.group({
      nombres: ['', Validators.required],
      email: ['', Validators.required],
      empresa: ['', Validators.required],
      telefono: ['', Validators.required],
      pais: ['', Validators.required],
    });
    this.registerForm.valueChanges.subscribe(x => {
      if (this.registerForm.valid) {
        this.habilitarEnviar = 1;
      } else this.habilitarEnviar = 0;
    })
  }

  async enviar() {
    await this.functions.httpsCallable("capacitacionEmpresa")(this.registerForm.value).toPromise();
    this.enviado = true;
  }


}
